<template>
  <AppPageContainer :showNav="false" :clean="true" :background="'calendar'">
    <div class="homespace">
      <!-- <VueDraggableResizable style="border: unset" :handles="[]" :parent="true" :w="300" :h="300" :x="0" :y="0">
        <div class="widget">
          <HomespacePomodoroTimer />
        </div>
      </VueDraggableResizable> -->
<!--       <VueDraggableResizable style="border: unset" :handles="[]" :parent="true" :w="300" :h="400" :x="50" :y="50">
        <div class="widget">
          <div class="note">
            <ELYXEditor :placeholder="'Add some additional details.'" v-model="temporaryNote" />
          </div>
        </div>
      </VueDraggableResizable> -->
      <VueDraggableResizable style="border: unset" :handles="[]" :parent="true" :w="600" :h="700" :x="550" :y="150">
        <div class="widget">
          <HomespaceMyDay />
          <!-- <div class="helpers">
            <button class="tool helper-quick">Delete</button>
          </div> -->
        </div>
      </VueDraggableResizable>
      <HomespaceDock />
    </div>
  </AppPageContainer>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer";
/* import ELYXEditor from "../../ELYXComponents/ELYXEditor.vue"; */
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
/* import HomespacePomodoroTimer from "./HomespacePomodoroTimer.vue"; */
import HomespaceDock from "./HomespaceDock.vue";
import HomespaceMyDay from "./HomespaceMyDay.vue";

export default {
  components: {
    AppPageContainer,
/*     ELYXEditor, */
    VueDraggableResizable,
/*     HomespacePomodoroTimer, */
    HomespaceDock,
    HomespaceMyDay,
  },
  data: function () {
    return {
      temporaryNote: "",
      containers: [],
    };
  },
};
</script>

<style>
.homespace {
  height: 100%;
  width: 100%;
  /* border: 1px solid red; */
  position: relative;
  box-sizing: border-box;
    --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position: ;
  --tw-gradient-via-position: ;
  --tw-gradient-to-position: ;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  --tw-text-opacity: 1;
  min-height: 100vh;
  color: var(--text);
  --border-radius: 0.75rem;
  --blur: 2rem;
  --tooltip-bg: rgba(0, 0, 0, 0.25);
  --glass-bg: transparent;
  --bg-transparent: rgba(0, 0, 0, 0.1);
  --bg: rgba(0, 0, 0, 0.05);
  --bg-light: rgba(0, 0, 0, 0.5);
  --bg-hover: rgba(0, 0, 0, 0.1);
  --border-color: rgba(255, 255, 255, 0.5);
  --border-color-lighter: rgba(255, 255, 255, 0.15);
  --border-hover: rgba(255, 255, 255, 1);
  --text: white;
  --text-secondary: white;
  --text-inverse: black;
  --placeholder: rgba(255, 255, 255, 0.7);
}
.widget {
  padding: 5px;
  height: 100%;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(var(--blur));
  backdrop-filter: blur(var(--blur));
  border: 1px solid var(--border-color-lighter);
  transition: border-color 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 0 10px 1px #0000001a;
  background-color: var(--glass-bg);
}
.widget:hover {
/*   border-color: var(--border-color); */
}
.homespace-timer {
  border: unset;
}
.homespace-note {
  border: unset;
}
</style>
